//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SchoolEventPolicySignUpSettingsDisplayItem extends ItemBase {
    AllowStudentPortalEventSignup: boolean = false;
    CreateNotification: boolean = false;
    HoursUntilDeadline: number = 0;
    AdvanceBookingLimitDays: number = 0;
    EventHoldExpiry: number = 0;
    StudentPortalSignupMakeupRequired: boolean = false;

    constructor(initializer?: Partial<SchoolEventPolicySignUpSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicySignUpSettingsDisplayItem";
}
